import { render, staticRenderFns } from "./ContractTesting.vue?vue&type=template&id=490ef41c&scoped=true"
import script from "./ContractTesting.vue?vue&type=script&lang=js"
export * from "./ContractTesting.vue?vue&type=script&lang=js"
import style0 from "./ContractTesting.vue?vue&type=style&index=0&id=490ef41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ef41c",
  null
  
)

export default component.exports